import AccessDialog from "./AccessDialog";

export default AccessDialog;